import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../types/state/root.types';
import { Notice } from '../../../types/common.types';

import SystemNotice from './system-notice/SystemNotice';

import './system-notices.scss';

const SystemNotices = (): ReactElement => {
  const notices: Notice[] = useSelector((state: RootState): Notice[] => state.system.notices);

  return (
    <div className="system-notices">
      {notices.map((notice: Notice): ReactElement => {
        return <SystemNotice key={notice.id} notice={notice} />;
      })}
    </div>
  );
};

export default SystemNotices;
